// extracted by mini-css-extract-plugin
export var container = "_q-1";
export var copyright = "_q-3";
export var footer = "_q-0";
export var logo = "_q-2";